export class DocumentSearchParameters {

    id: string = "";
    buyerID: number = 0;
    supplierID: number = 0;
    pageNumber: number = 0;

}